import React, { useState, useEffect } from 'react';
import '../../css/Pages.css';
import LanguageListing from '../../components/CategoryManagement/Language/LanguageListing';
import { ALL_ISO_CODES } from '../../data/isoCodes';

const Language = () => {
    const [languages, setLanguages] = useState([]);
    const [filteredLanguages, setFilteredLanguages] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const viTranslator = new Intl.DisplayNames(['vi'], { type: 'language' });
        const enTranslator = new Intl.DisplayNames(['en'], { type: 'language' });

        setTimeout(() => {
            const generatedData = ALL_ISO_CODES.map(code => {
                let nameVi = viTranslator.of(code) || code;
                let nameEn = enTranslator.of(code) || code;
                nameVi = nameVi.charAt(0).toUpperCase() + nameVi.slice(1);

                return { code, nameVi, nameEn };
            })
                .filter(lang => lang.nameVi.toLowerCase() !== lang.code.toLowerCase())
                .sort((a, b) => a.nameVi.localeCompare(b.nameVi));

            setLanguages(generatedData);
            setFilteredLanguages(generatedData);
            setIsLoading(false);
        }, 600);
    }, []);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = languages.filter(lang =>
            lang.nameVi.toLowerCase().includes(query) ||
            lang.nameEn.toLowerCase().includes(query) ||
            lang.code.toLowerCase().includes(query)
        );
        setFilteredLanguages(filtered);
    };

    const handleReset = () => {
        setSearchQuery('');
        setFilteredLanguages(languages);
    };

    return (
        <div className="page-container">
            <div className="page-header" style={{ marginBottom: '10px' }}>
                <div className="header-title">
                    <h2>DANH MỤC NGOẠI NGỮ</h2>
                </div>
            </div>

            <div style={isDesktop
                ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }
                : { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' }
            }>
                <p className="sub-title" style={{ margin: 0 }}>DANH SÁCH TOÀN BỘ NGOẠI NGỮ</p>

                <div style={isDesktop
                    ? { display: 'flex', gap: '10px' }
                    : { display: 'flex', gap: '10px', width: '100%', alignItems: 'stretch' }
                }>
                    <div style={isDesktop ? {} : { flex: 1 }}>
                        <input
                            type="text"
                            placeholder="Tra cứu tên ngôn ngữ hoặc mã ISO"
                            className="form-input"
                            style={isDesktop
                                ? { width: '300px', padding: '8px 15px' }
                                : { width: '100%', padding: '8px 15px', boxSizing: 'border-box', height: '100%' }
                            }
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <button
                        onClick={handleReset}
                        className="btn-add-new"
                        style={isDesktop
                            ? { margin: 0, padding: '8px 15px', backgroundColor: '#6c757d' }
                            : { margin: 0, padding: '0', width: '45px', flex: '0 0 45px', backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        }
                        title="Tải lại dữ liệu"
                    >
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>

            <LanguageListing
                data={filteredLanguages}
                isLoading={isLoading}
                searchQuery={searchQuery}
            />
        </div>
    );
};

export default Language;